<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <router-view />
    </v-content>
  </div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      dialog: false
    };
  },
  created() {
    this.$vuetify.theme.dark = false;
  },
  mounted() {},
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "SaaS Pricing Pages";
      }
    }
  },

  methods: {}
};
</script>

<style scoped>
.v-btn {
  margin-left: 10px;
}
</style>
